module.exports = __webpack_public_path__ + "04_face.d7ead850.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer1/04_face.png
// module id = 6BG8
// module chunks = 0